/**
 * A builder method that returns the <a href='https://dev.wix.com/docs/sdk/host-modules/dashboard/navigate#destination-object'>destination object</a> for navigating to the Products List page in the dashboard.
 * @dashobardPageBuilder
 */
export function productsList(): PageBuilderResult {
  return { pageId: 'c821a776-85a9-4340-ae94-e08876c99944' };
}

export interface PageBuilderResult {
  pageId: string;
  relativeUrl?: string;
}
